/* ci-cart-experiment.js — arm stamping for the cart upsell slider test.
   Two jobs:
   1. FOUC guard: stamp .ci-v2cart on #rebuy-cart the INSTANT the variant
      widget node enters the DOM (MutationObserver), because the cart-level
      CSS is keyed on that class in the DOM shape where the widget renders
      outside #rebuy-cart, and waiting for the widget callback's 100-600ms
      timers paints a default-styled cart first.
   2. Analytics: on every Smart Cart open, detect the arm (307574 = slider
      variant, 141325 = control) and push ci_cart_open so funnels segment by
      arm; window.__ciArm feeds the variant callback's events. 'unknown'
      means neither widget had rendered yet — count it separately, don't
      guess. Safe to leave in place after the test ends. */
(function () {
  function stamp() {
    var w = document.getElementById('rebuy-widget-307574');
    var cart = document.getElementById('rebuy-cart');
    if (w && cart && !cart.classList.contains('ci-v2cart')) {
      cart.classList.add('ci-v2cart');
    }
    return !!(w && cart);
  }
  if (!stamp()) {
    var mo = new MutationObserver(function () { if (stamp()) mo.disconnect(); });
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
    else document.addEventListener('DOMContentLoaded', function () {
      if (!stamp()) mo.observe(document.body, { childList: true, subtree: true });
    });
  }

  function detectArm() {
    if (document.getElementById('rebuy-widget-307574')) return 'slider';
    if (document.getElementById('rebuy-widget-141325')) return 'control';
    return 'unknown';
  }
  function report() {
    var a = detectArm();
    window.__ciArm = a;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'ci_cart_open', ci_cart_arm: a });
    if (window.gtag) { try { gtag('event', 'ci_cart_open', { ci_cart_arm: a }); } catch (e) {} }
  }
  /* widget renders async after the drawer opens; 400ms lets it land so the
     arm is not misread as 'unknown' on first open */
  document.addEventListener('rebuy:smartcart.show', function () { setTimeout(report, 400); });
})();
